import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export const RobFridPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const stats = [{
    label: 'Goals',
    value: '75'
  }, {
    label: 'Assists',
    value: '120'
  }, {
    label: 'Games Played',
    value: '440'
  }, {
    label: 'Career Span',
    value: '1992-2007'
  }];
  return <div className="pt-24 pb-20 bg-navy-900 min-h-screen" data-id="element-272">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} className="mb-8" data-id="element-274">
          <Link to="/" className="inline-flex items-center text-ice-500 hover:text-ice-400 font-semibold transition-colors group" data-id="element-275">
            <ArrowLeft className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform" data-id="element-276" />
            Back to Home
          </Link>
        </motion.div>

        <div className="bg-navy-800 border border-navy-700 rounded-sm overflow-hidden shadow-2xl" data-id="element-277">
          {/* Hero Section */}
          <div className="relative h-64 sm:h-80 md:h-96 bg-navy-700" data-id="element-278">
            <img src="https://cdn.magicpatterns.com/uploads/drnjLYkADkGvq7ohwJ1YTF/5754.png" alt="Rob Frid in action" className="w-full h-full object-cover object-center opacity-40" data-id="element-279" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-800 via-navy-800/60 to-transparent" data-id="element-280"></div>

            <div className="absolute bottom-0 left-0 w-full p-8 md:p-12 flex flex-col md:flex-row items-end gap-6 md:gap-8" data-id="element-281">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="w-32 h-36 md:w-40 md:h-48 shrink-0 rounded-sm overflow-hidden border-4 border-navy-800 shadow-xl bg-navy-700" data-id="element-282">
                <img src="https://cdn.magicpatterns.com/uploads/tNKtzo6iMqSY4iPn9J184Z/5752.png" alt="Rob Frid" className="w-full h-full object-cover object-center" data-id="element-283" />
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="mb-2 md:mb-6" data-id="element-284">
                <h1 className="text-4xl md:text-5xl font-black text-white tracking-tight mb-2" data-id="element-285">
                  Rob Frid
                </h1>
                <p className="text-ice-500 font-bold text-lg uppercase tracking-widest" data-id="element-286">
                  Founder & President of Development
                </p>
              </motion.div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-8 md:p-12" data-id="element-287">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="prose prose-lg prose-invert max-w-none" data-id="element-288">
              <p className="text-xl text-slate-300 leading-relaxed font-medium mb-8" data-id="element-289">
                Rob Frid, a Canadian former minor-league hockey player and now
                hockey skills instructor and development advisor and player
                placement director.
              </p>

              <div className="space-y-6 text-slate-400 leading-relaxed" data-id="element-290">
                <p data-id="element-291">
                  As a teenager he was drafted by the London Knights of the
                  Ontario Hockey League (OHL), where he spent multiple seasons.
                </p>
                <p data-id="element-292">
                  Although he received calls from NHL teams and attended the St.
                  Louis Blues free-agent tryout at 19 years old, he never broke
                  into the NHL.
                </p>
                <p data-id="element-293">
                  Frid played nearly nine seasons in minor professional hockey
                  across the United States in leagues like the ECHL and CHL,
                  WCHL, UHL, U Sports and attended several AHL training camps.
                </p>
              </div>

              {/* Stats Callout */}
              <div className="my-12 grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-294">
                {stats.map((stat, index) => <div key={index} className="bg-navy-900 border border-navy-700 p-6 rounded-sm text-center" data-id="element-295">
                    <div className="text-3xl font-black text-gold-500 mb-2" data-id="element-296">
                      {stat.value}
                    </div>
                    <div className="text-xs font-bold text-slate-400 uppercase tracking-widest" data-id="element-297">
                      {stat.label}
                    </div>
                  </div>)}
              </div>

              <div className="space-y-6 text-slate-400 leading-relaxed" data-id="element-298">
                <p data-id="element-299">
                  Frid's involvement demonstrates how experienced hockey mentors
                  can help young players transition and find roster spots in
                  junior, college and pro leagues. This has led to both Frid and
                  Scott Blair, who was a highly touted player out of USA Hockey
                  and went through that development system to establish
                  Universal Hockey Development.
                </p>
              </div>

              {/* Quote */}
              <blockquote className="mt-12 p-8 bg-navy-900/50 border-l-4 border-ice-500 rounded-r-sm" data-id="element-300">
                <p className="text-xl italic text-slate-300 font-medium m-0" data-id="element-301">
                  "We don't just build players; we build resilient individuals
                  ready for any challenge the game throws at them."
                </p>
              </blockquote>
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
};